module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDM2IDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0wIDBoMzZ2MjRoLTcyeiIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Ik0yMSAwdjloMTV2NkgyMXY5aC02di05SDBWOWgxNVYweiIgZmlsbD0iI2U4MTEyZCIvPjxwYXRoIGQ9Ik05IDE0bDEtMWg3djdsLTEgMWg0bC0xLTF2LTdoN2wxIDF2LTRsLTEgMWgtN1Y0bDEtMWgtNGwxIDF2N2gtN2wtMS0xeiIgZmlsbD0iI2Y5ZGQxNiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/ggy.svg
// module id = Ynr0
// module chunks = 0